import React, { useContext, useEffect } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import { useImmer } from "use-immer";

import Header from "../components/Header";
import ChapitreContent from "../components/ChapitreContent";
import Cle from "../components/Cle";

function Chapitre() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const [isLoading, setIsLoading] = useImmer(true);

  const { chapitreId } = useParams();
  const chapitre = appState.chapitres.find(
    (chapitre) => chapitre.id === parseInt(chapitreId)
  );
  const chapitreIdx = appState.chapitres.indexOf(chapitre);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setIsLoading(false);
  }, []);

  useEffect(() => {
    let allContentUnlocked = true;
    for (let pauseIdx in appState.status[chapitreIdx].pauses) {
      for (let contentIdx in appState.status[chapitreIdx].pauses[pauseIdx]
        .contenus) {
        if (
          appState.status[chapitreIdx].pauses[pauseIdx].contenus[contentIdx]
            .locked == true
        ) {
          allContentUnlocked = false;
        }
      }
    }
    if (allContentUnlocked) {
      appDispatch({
        type: "UPDATE_CHAPTER_LOCK_STATUS_FROM_CONTENT",
        chapitreIdx: chapitreIdx,
        value: !allContentUnlocked,
      });
    }
  }, [appState.lockCounter]);

  if (isLoading) return <></>;

  return (
    <>
      <Header
        pageName="chapitre"
        titre={chapitre.titre}
        sousTitre={chapitre.sousTitre}
        showStart={false}
        showMascotte={true}
        isbn={appState.livre.isbn}
        chapitreId={chapitre.id}
      />
      <Routes>
        <Route
          path="/"
          element={
            <ChapitreContent
              {...chapitre}
              chapitreId={chapitreId}
              chapitreIdx={chapitreIdx}
            />
          }
          exact
        />
        <Route
          path="/cle/"
          element={
            <Cle
              {...chapitre}
              chapitreId={chapitreId}
              chapitreIdx={chapitreIdx}
            />
          }
          exact
        />
      </Routes>
    </>
  );
}

export default Chapitre;
